import React, { useEffect, useState } from "react";
import styled from "styled-components";
// import { PaymentSuccess, PaymentFailed, PlsWait } from "../modal/container.jsx";
import copyIcon from "../../assets/svgs/copy.svg";
import clockIcon from "../../assets/svgs/clock.svg";
import expiredClock from "../../assets/svgs/red-clock.svg";
// import { Button, CancelButton } from "../button/button.jsx";
import axios from "axios";
import config from "../../config.js";
import { formatTime } from "../../utils/formatTime.js";
// import { WqSwal as Swal } from "../../utils/themedSwal";
import { WqToast as toast } from "../../utils/themedToast";
import styles from "./bankTransfer.module.css";
import { ContentsContainer } from "../card/cardcontainer.jsx";
import { hideLoader, showLoader } from "../../utils/loader.jsx";
import {
  getEmbedContext,
  // notifyParent
} from "../../utils/embed.js";
import { finalizePaymentSuccess, showPaymentError, showPaymentPending } from "../../utils/paymentOutcomes.js";




const initialMinutes = 30;
export const BankTransfer = ({transferData}) => {
  // const [modals, setModals] = useState("");
  const [amount, setAmount] = useState(null);
  // const [merchantName, setMerchantName] = useState("");
  // const [productName, setProductName] = useState("");
  const [isExpired, setIsExpired] = useState(false);
  const [time, setTime] = useState(initialMinutes * 60);
  const [accountDetails, setAccountDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [validUntil, setValidUntil] = useState(null);
  const refNo = sessionStorage.getItem("tranId") || new URLSearchParams(window.location.search).get("_tranId");
  const { isEmbedded } = getEmbedContext();

  useEffect(() => {
    if (!transferData) return;
    const productData = JSON.parse(sessionStorage.getItem("product_data") || "null");
    setAmount(productData?.amount || "")
    // setMerchantName(productData?.merchant_business_name || "")
    // setProductName(productData?.product_name || "")
    
  
    const { accountData } = transferData;
  
    setAccountDetails(accountData);

    const expiryTime = new Date(
      accountData.validUntil.replace(" ", "T")
    ).getTime();
  
    setValidUntil(expiryTime);
  }, [transferData]);
  

  const copyToClipboard = () => {
    toast.success("account copied")
    if (accountDetails) {
      navigator.clipboard.writeText(accountDetails.accountNo);

    }
  };

  useEffect(() => {
    if (!validUntil) return;

    const updateTime = () => {
      const now = Date.now();
      const diff = Math.floor((validUntil - now) / 1000);

      if (diff <= 0) {
        setIsExpired(true);
        setTime(0);
      } else {
        setTime(diff);
      }
    };

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [validUntil]);

  // const finalizeSuccess = (message) => {
  //     Swal.fire({
  //       title: "Success",
  //       text: message || "Payment successful",
  //       icon: "success",
  //       confirmButtonText: "Ok",
  //       timer: 10000,
  //       timerProgressBar: true,
  //     }).then(() => {
  //       const callback = sessionStorage.getItem("fallbackUrl");
  //       const referrer = sessionStorage.getItem("referrer");
  //       const isBadReferrer =
  //         referrer?.includes("payment-link") || referrer?.includes("_tranId");
  
  //       let redirectUrl;
  //       if (callback) {
  //         redirectUrl = callback;
  //       } else if (referrer && !isBadReferrer) {
  //         redirectUrl = referrer;
  //       } else {
  //         redirectUrl = "https://wayaquick.com";
  //       }
  //       if (isEmbedded) {
  //         sessionStorage.clear();
  //         notifyParent("success");
  //         return;
  //       }
  //       sessionStorage.setItem("paymentCompleted", "true");
  //       const completedFlag = sessionStorage.getItem("paymentCompleted");
  //       sessionStorage.clear();
  //       sessionStorage.setItem("paymentCompleted", completedFlag);
        
  
  //       const isPopup = window.opener && !window.opener.closed;
  //       if (isPopup) {
  //         window.opener.postMessage(
  //           { type: "PAYMENT_SUCCESS", tranId: refNo },
  //           "*"
  //         );
  //         window.close();
  //       } else {
  //         window.location.replace(redirectUrl);
  //       }
  //     });
  // };
  
  // const showError = (err, fallback) => {
  //     Swal.fire({
  //       title: "Error",
  //       text:
  //         err?.response?.data?.message ||
  //         err?.response?.data?.description ||
  //         fallback ||
  //         "Something went wrong, please try again",
  //       icon: "error",
  //       confirmButtonColor: "#3085d6",
  //       confirmButtonText: "Ok",
  //     });
  // };
  
  // const showPending = () => {
  //   Swal.fire({
  //     title: "Payment Pending",
  //     text: "Your transfer has not been received yet. Please wait a moment and try again.",
  //     icon: "info",
  //     confirmButtonText: "Okay",
  //     confirmButtonColor: "#3085d6",
  //     allowOutsideClick: false,
  //   });
  // };
  


  const confirmTransfer = () => {
    // setModals("wait"); 
    showLoader();
    const tranId = sessionStorage.getItem("tranId");
    if (tranId) {
      axios
        .get(`${config.API_ROOT_ADDRESS}/api/v1/payment/transfer/confirm/${tranId}`)
        .then((response) => {
          // if (response.data.status) {
          //   setModals("success");
          //   finalizeSuccess(response?.data?.message);
          // } else {
          //   setErrorMessage(response.data.message);
          //   setModals("failed");
          // }
          hideLoader();
          if (response?.data?.status === false && response?.data?.message === "Could not verify payment status. Please try again shortly.") {
            // showPending();
            showPaymentPending();
            return;
          }

          if (response?.data?.status === false) {
            // showError(null, response?.data?.message);
            // showPending();
            showPaymentPending();
            return;
          }
          
          // finalizeSuccess(response?.data?.message);
          // const message = response?.data?.message
          finalizePaymentSuccess({ message: response?.data?.message, refNo, isEmbedded });
        })
        .catch((error) => {
          hideLoader();
          // console.error("Error confirming transfer:", error);
          // showError(error, "An error occured. Unable to confirm transfer");
          showPaymentError(error, "An error occured. Unable to confirm transfer")
          setErrorMessage(error.response?.data?.message || "An error occurred.");
          return;
          // setModals("failed");
        });
    } else {
      hideLoader();
      setErrorMessage("Transaction ID not found.");
      return;
      // setModals("failed");
    }
  };


  return (
    <>
      
      <ContentsContainer>
      <div className={styles.cardcontainer}>
          <TextPrompt>
            <p className="text-prompt">
              Transfer {amount ? `NGN ${amount}.00` : ""} to account details below
            </p>
          </TextPrompt>
          <TransferContainer>
            {accountDetails && (
              <>
                <InfoValue>
                  <p className="transfer-title"> Bank Name</p>
                  <p className="transfer-value">{accountDetails.bankName}</p>
                </InfoValue>

                <InfoValue>
                  <p className="transfer-title"> Account Number</p>
                  <p className="transfer-value transfer-account">
                    {accountDetails.accountNo}{" "}
                    <button className="copy-btn" onClick={copyToClipboard}>
                      <img
                        src={copyIcon}
                        alt="copy"
                        className="copy-icon"
                        title="copy"
                        style={{ marginLeft: "10px", height: "30px" }}
                      />
                    </button>
                  </p>
                </InfoValue>
                <InfoValue>
                  <p className="transfer-title"> Account Name</p>
                  <p className="transfer-value">{accountDetails.accountName}</p>
                </InfoValue>
              </>
            )}
            {isExpired && (
              <p className="expired-text">
                <img
                  src={expiredClock}
                  alt="clock"
                  className="clock-icon"
                  title="clock"
                  style={{ marginRight: "10px", height: "20px" }}
                />
                Expired
              </p>
            )}
            {!isExpired && (
              <TextPrompt
                style={{
                  
                  marginTop: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <p className="text-prompt">
                  <img
                    src={clockIcon}
                    alt="clock"
                    className="clock-icon"
                    title="clock"
                    style={{ marginRight: "10px" }}
                  />
                  Expires in: {formatTime(time)}
                </p>
              </TextPrompt>
            )}

{errorMessage && (
              <TextPrompt
                style={{
                  
                  marginTop: "1rem",
                  marginBottom: "1rem",
                }}
              >
                {errorMessage}
              </TextPrompt>
            )}

            <SubmitBtn
              type={"button"}
              active={true}
              onClick={confirmTransfer}
              disabled={isExpired}
            >
              I have Completed the transfer
            </SubmitBtn>
          </TransferContainer>
          </div>
        </ContentsContainer>
      

      {/* {modals === "success" && (
        <ModalContainer>
          <PaymentSuccess merchantName={merchantName} amount={amount} setModals={setModals} productName={productName} />
        </ModalContainer>
      )}
      {modals === "failed" && (
        <ModalContainer>
          <PaymentFailed message={errorMessage} />
        </ModalContainer>
      )}
      {modals === "wait" && (
        <ModalContainer>
          <PlsWait />
        </ModalContainer>
      )} */}
    </>
  );
};

const TextPrompt = styled.div`
  
  // border: 1px solid red;
   padding: 10px;
   margin: 0 10px; 
  display: flex;
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .text-prompt {
    font-weight: 700;
  }
`;

// const ModalContainer = styled.div`
//   background-color: rgba(0, 0, 0, 0.7);
//   /* width: 100%; */
//   /* height: 100vh; */
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   right: 0;
//   left: 0;
// `;

const TransferContainer = styled.div`
  // background-color: #f9fafb;
  width: 100%;
  // border: 1px solid red;
  border-radius: 8px;
  margin-top: 0.5rem;
  // padding: 0 10px;
  // box-sizing: border-box!important;
  .expired-text {
    color: #9e0a05;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    border-radius: 20px;
    background-color: #fbeae9;
    width: 150px;
    padding: 10px;
    margin: 16px auto;
  }
`;

const InfoValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  .copy-btn {
    background-color: transparent;
    border: transparent;
  }
  .copy-icon {
    &:hover {
      cursor: pointer;
    }
  }

  .transfer-value {
    font-weight: 700;
    display: flex;
    align-items: center;
    margin: 5px 0;
  }
  .transfer-account {
    font-size: 20px;
  }
`;

const SubmitBtn = styled.button`
  border: transparent;
  background-color: #e85c2a;
  border-radius: 8px;
  padding: 20px 20px;
  margin: 0 10px;
  box-sizing: border-box;
  width: 95%;
  color: white;
  &[disabled] {
    cursor: not-allowed !important;
    background: #d0d5dd;
  }
`;


